module.exports = __webpack_public_path__ + "static/media/news-04.cd7f8571.jpg";